import { generateAccountLoginUrl } from "../cart/customerAccountApi";

class CustomerLoginLink extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    generateAccountLoginUrl.then((url) => {
      if (this.hasAttribute("redirect")) {
        window.location = url;
      } else {
        this.parentElement?.setAttribute("href", url);
      }
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("customer-login-link")) {
  customElements.define("customer-login-link", CustomerLoginLink);
}
